import type { ReactNode } from 'react';
import { memo } from 'react';
import styles from './SplitScreenLayout.module.css';

interface SplitScreenLayoutProps {
  leftPanel: ReactNode;
  rightPanel: ReactNode;
  settingsBar?: ReactNode;
  leftPanelBackground?: ReactNode;
  showAccentLine?: boolean;
}

export const SplitScreenLayout = memo(function SplitScreenLayout({
  leftPanel,
  rightPanel,
  settingsBar,
  leftPanelBackground,
  showAccentLine = true,
}: SplitScreenLayoutProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.leftPanel}>
        {showAccentLine && <div className={styles.accentLine} />}
        {leftPanelBackground && (
          <div className={styles.leftPanelBackground}>
            {leftPanelBackground}
          </div>
        )}
        <div className={styles.leftPanelContent}>{leftPanel}</div>
      </div>
      <div className={styles.rightPanel}>
        {settingsBar && <div className={styles.settingsBar}>{settingsBar}</div>}
        {rightPanel}
      </div>
    </div>
  );
});
